if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"hydra","remotes":[{"alias":"menu","name":"menu","entry":"https://concentrixcx.azureedge.net/uat/react-module/menu/remoteEntry.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(8(58|79|88)|506|656|750|933|992)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}